export const MD_MAX_WIDTH = 1024;

export const CATALOGS_WIDTH = 300;

export const VIDEO_WITH_4XL = 1280;
export const VIDEO_WITH_XXL = 910;
export const VIDEO_WITH_XL = 810;
export const VIDEO_WITH_LG = 660;
export const VIDEO_WITH_MD = 768;
export const VIDEO_WITH_SM = 320;

export const VIDEO_RATIOS = 9 / 16;